import { List, Map } from 'immutable';
import moment from 'moment';

import createTypedReducer from '../createTypedReducer';
import * as noteActions from './action';
import { CHANGE_CLIENT, CLEAR } from '../authentication/action';

export const initialState = Map({
  notes: Map()
});

function resetState (state) {
  return state.withMutations((nextState) =>
    nextState.set('notes', Map())
      .set('lotoPage', Map())
      .set('nuisancePage', Map())
      .set('notePage', Map())
      .set('facilityPage', Map())

  );
}

export const noteReducer = createTypedReducer(initialState, {
  [noteActions.FETCH_NOTES] (state, action) {
    return state.withMutations((nextState) => {
      const page = `${action.note}Page`;
      nextState.setIn([page, 'loading'], true);
    });
  },

  [noteActions.FETCH_NOTES_SUCCESS] (state, action) {
    return state.withMutations((nextState) => {
      const fetchDate = new Date();
      let newDataIds = List();
      action.notes.map((note) => {
        newDataIds = newDataIds.push(note.get('id'));
        nextState.setIn(['notes', 'data', note.get('id')], {
          record: note,
          lastFetch: fetchDate,
        });
      });
      const page = `${action.noteType}Page`;
      nextState.setIn([page, 'records'], newDataIds);
      nextState.setIn([page, 'total'], action.total);
      nextState.setIn([page, 'totalPages'], action.totalPages);
      nextState.setIn([page, 'loading'], false);
    });
  },

  [noteActions.FETCH_NOTES_FAILED] (state, action) {
    return state.withMutations((nextState) => {
      const page = `${action.noteType}Page`;
      nextState.setIn([page, 'loading'], false);
    });
  },

  [noteActions.UPDATE_NOTE_SUCCESS] (state, action) {
    return state.withMutations((nextState) => {
      const noteId = action.note.get('id');
      const page = `${action.note.get('note')}Page`;
      if (action.note.get('archived_at')) {
        nextState.getIn(['notes', 'data']).delete(noteId);
        nextState.setIn([page, 'records'], nextState.getIn([page, 'records'])?.filter(x => x !== noteId));
        nextState.setIn([page, 'total'],  nextState.getIn([page, 'total'])-1);
      } else {
        nextState.mergeIn(['notes', 'data', noteId, 'record'], action.note);
      }

      return nextState;
    });
  },
  [noteActions.ADD_NOTE_SUCCESS] (state, action) {
    return state.withMutations((nextState) => {
      const page = `${action.note.get('note')}Page`;
      nextState.setIn(['notes', 'data', action.note.get('id'), 'record'], action.note);
      nextState.setIn(['notes', 'data', action.note.get('id'), 'lastFetch'], new Date());
      const noteList = nextState.getIn([page, 'records'], List()).push(action.note.get('id'));
      nextState.setIn([page, 'records'], noteList);
      nextState.setIn([page, 'total'], nextState.getIn([page, 'total'])+1);
      return nextState;
    });
  },


  [noteActions.LOAD_NOTES_FROM_DEVICE] (state, action) {
    return state.withMutations((nextState) => {
      const fetchDate = new Date();
      action.notes.map((note) => {
        nextState.setIn(['notes', 'data', note.get('id')], {
          record: note,
          lastFetch: fetchDate,
        });
      });
      return nextState;
    });
  },
  [noteActions.FETCH_NOTES_EXPORT] (state) {
    return state.withMutations((nextState) => {
      nextState.setIn(['exportNotes', 'loading'], true);
    });
  },

  [noteActions.FETCH_NOTES_EXPORT_SUCCESS] (state, action) {
    const notes = action.exportNotes;

    return state.withMutations((nextState) => {
      const now = moment();
      const today = now.format('YYYY-MM-DD');

      const blob = new Blob([notes], { type: 'text/csv;charset=utf-8,' });
      const objUrl = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.setAttribute('href', objUrl);

      const noteType = (action.noteType === 'all' || action.noteType ==='note') ? 'notes' : `${action.noteType}-notes`;
      const filename = action.deviceTag ? `${today}-${action.deviceTag}-notes.csv` : `${today}-${action.facilityName}-${noteType}.csv`;

      link.setAttribute('download', filename);
      link.click();
      return nextState.setIn(['exportNotes', 'loading'], false)
        .setIn(['exportNotes', 'data'], notes);
    });
  },

  [noteActions.FETCH_NOTES_EXPORT_FAILED] (state) {
    return state.withMutations((nextState) => {
      nextState.setIn(['exportNotes', 'loading'], false);
    });
  },

  [noteActions.CLEAR_NOTES_EXPORT] (state) {
    return state.withMutations((nextState) => {
      nextState.setIn(['exportNotes', 'loading'], false);
    });
  },

  [CLEAR] (state) {
    return resetState(state);
  },

  [CHANGE_CLIENT] (state) {
    return resetState(state);
  }
});

export default noteReducer;
